import React from 'react';

export const Error = () => {
  return (
    <div className="">
     ошибка
    </div>
  );
};
